import type {Dispatch, ThunkAction} from 'src/reducers';
import type {ActionAttributeSchema} from 'src/types/action-based-targeting-meta';
import {thunkify as flow} from 'src/utils/thunks';
import {key, cached, fetching} from 'src/utils/redux';
import {camel} from 'src/utils';
import * as reduxApi from 'src/utils/redux-api-bff';


export const RECEIVE_ABT_ATTRIBUTES = 'abt-attributes/receiveAll';

type ReceiveAbtAttributesAction = {
  type: typeof RECEIVE_ABT_ATTRIBUTES;
  payload: ActionAttributeSchema[];
};

export type AbtAttributesAction = ReceiveAbtAttributesAction;

const receiveAttributes = (
  attributes: ActionAttributeSchema[],
): ReceiveAbtAttributesAction => ({
  type: RECEIVE_ABT_ATTRIBUTES,
  payload: attributes,
});

export const getABTAttributes: () => ThunkAction<void> = flow(
  key(() => 'ABTAttributes'),
  cached(({labels: attributes}) => receiveAttributes(camel(attributes)), {
    ttl: 60 * 60 * 1000,
  }),
  fetching(),
)(() => (dispatch: Dispatch) => dispatch(reduxApi.get('action_metadata')));
